export default __webpack_public_path__ + "static/media/Close.c96c441b.svg";